import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ChoferSucursalService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerchoferSucursalxRutEmpresaSucursal(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: chofer_sucursalJoinInputType) {
          chofer_sucursal {
            obtenerchoferSucursalxRutEmpresaSucursal(entidad: $entidad, paginaActual: 1, cantidadRegistrosPorPagina: -1) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  rut
                  nombre
                  estado
                  fono1
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.chofer_sucursal.obtenerchoferSucursalxRutEmpresaSucursal;
            callback({ mensajes, respuesta });
        });
    }
    agregarEditarChoferSucursal(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation($entidad: chofer_sucursalJoinInputType) {
          chofer_sucursal {
            agregaroEditarchoferSucursal(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rut
                nombre
                estado
                es_cliente
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.chofer_sucursal.agregaroEditarchoferSucursal;
            callback({ mensajes, respuesta });
        });
    }
}
ChoferSucursalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ChoferSucursalService_Factory() { return new ChoferSucursalService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ChoferSucursalService, providedIn: "root" });
